var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2499 5.17951H9.99996C9.33693 5.17951 8.70105 5.4429 8.23221 5.91173C7.76337 6.38057 7.49998 7.01645 7.49998 7.67949V27.6793C7.49998 28.3424 7.76337 28.9783 8.23221 29.4471C8.70105 29.9159 9.33693 30.1793 9.99996 30.1793H24.9999C25.6629 30.1793 26.2988 29.9159 26.7676 29.4471C27.2364 28.9783 27.4998 28.3424 27.4998 27.6793V18.4294M5 10.1795H9.99996M5 15.1794H9.99996M5 20.1794H9.99996M5 25.1794H9.99996M29.2223 9.71197C29.7203 9.21403 30 8.53868 30 7.83449C30 7.13029 29.7203 6.45494 29.2223 5.957C28.7244 5.45906 28.049 5.17932 27.3448 5.17932C26.6406 5.17932 25.9653 5.45906 25.4673 5.957L19.2049 12.222C18.9077 12.519 18.6902 12.8861 18.5724 13.2894L17.5262 16.8769C17.4948 16.9845 17.4929 17.0985 17.5207 17.207C17.5485 17.3156 17.605 17.4146 17.6842 17.4939C17.7634 17.5731 17.8625 17.6296 17.971 17.6574C18.0796 17.6852 18.1936 17.6833 18.3012 17.6519L21.8886 16.6057C22.292 16.4879 22.6591 16.2704 22.9561 15.9732L29.2223 9.71197Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.717ac73eedbd77a025c2ef46949b167a.svg";
export { ForwardRef as ReactComponent };